import React from "react";

import {
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem
} from 'mdbreact';

import { connect } from 'react-redux';

import { EnviarCredencialesInfoEnAPI, BajaLicenciaInfoEnAPI, ObtenerLicenciasInfoEnAPI, GetListaHTMLEnAPI, GetCSVEnAPI, GetListaPDFEnAPI } from "../../action/actionCreatorsRequests";
import {
    MSGOK, obtenerUsuario, ordenarTablaLocal, traducirPagina, descargarPdfPasandoBase64, descargarDocPasandoBase64Generico, obtenerToken

} from "../../librerias/funciones"
import ReactDOM from "react-dom";


import ListadoClientes from '../NextAssist/ListadoClientes'
import { Button, Modal, Select, Row, Col, Pagination } from 'antd';
import {
    CloseOutlined,
    SearchOutlined,
    PlusOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    CheckSquareOutlined,
    CloseSquareOutlined,
    ShopOutlined,
    UserOutlined,
    DesktopOutlined,
    MailOutlined,
    PrinterOutlined,
    EditOutlined,
    FundViewOutlined,
    DeleteOutlined,
    UnlockOutlined

} from '@ant-design/icons';


import { Layout } from 'antd';
import FichaClienteDataInfo from "./FichaClienteDataInfo";
import FichaImpresionGenerico from "../FichaImpresionGenerico";
const { Content } = Layout;
const { Option } = Select;

const ContainerLicenciasNextInfo = ({ activeItemReferencia, configApp, props, usuario }) => {
    const [ABRIR_FICHA_IMPRESION, setABRIR_FICHA_IMPRESION] = React.useState(false);
    const [DOC_HTML, setDOC_HTML] = React.useState("");

    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [hayLicencias, seHayLicencias] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");

    const [sociosLocal, setSociosLocal] = React.useState([]);

    const [abrirFichaSelecionCliente, setAbrirFichaSelecionCliente] = React.useState(false);



    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [usuarioSeleccionado, setUusuarioSeleccionado] = React.useState(0);
    const [registroUsuario, setRegistroUsuario] = React.useState({});
    const [visible, setVisible] = React.useState(false);
    const [registroTabla, setRegistroTabla] = React.useState([]);

    const [cabeceraTabla, setCabeceraTabla] = React.useState(
        {
            ID: false,
            Usuario: false,
            Nombre: false,
            Taller: false,
            Mail: false,
            Almacen: false,
            Cliente: false,
            Creación: false,
            Ultimo: false,
            Media: false,
            Activo: false,
            EsMostrador: false,
            Baja: false
        }
    );
    const [estadoCliente, setEstadoCliente] = React.useState(false);
    const [estadoMostrador, setEstadoMostrador] = React.useState(false);

    const [abrirFichaCliente, setAbrirFichaCliente] = React.useState(false);
    const [datosClienteSeleccionado, setDatosClienteSeleccionado] = React.useState({});
    const [licencias, setLicencias] = React.useState([]);
    const [licenciasAux, setLicenciasAux] = React.useState([]);

    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });

    const [filtroActivo, setFiltroActivo] = React.useState(0);
    const [filtroPorDecto, setFiltroPorDecto] = React.useState(0);

    const [filtroLocal, setFiltroLocal] = React.useState({
        PROGRAMAS: [],
        VERSIONES: [],
        PROGRAMA_SELECCIONADO: 0,
        VERSION_SELECCIONADO: 0,

    });






    const filtroLocalDeLaTabla = (textoAFiltrar, licenciasAux) => {
        let registrosEncontrados = [];
        let filtro = [...licenciasAux];

        if (textoAFiltrar.trim() !== "") {
            if (filtro !== null) {
                setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })

                filtro.find(function (registro, i) {
                    if (registro.ID.toString().toLowerCase().includes(textoAFiltrar.toLowerCase()) || registro.ID.toString().toLowerCase() === textoAFiltrar.toLowerCase()) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }

                    }





                    if (registro.USUARIO.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.NOMBRE_TALLER.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }




                    if (registro.NOMBRE_TALLER.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.NOMBRE_RED.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.DISENYO.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.VERSION.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.FECHA_ALTA.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }

                    if (registro.FECHA_BAJA.toString().toLowerCase().includes(textoAFiltrar.toLowerCase())) {
                        let existeRegistro = registrosEncontrados.find(reg => reg.ID === registro.ID)
                        if (existeRegistro === undefined) {
                            registrosEncontrados.push(registro)
                        }
                    }
                })

            }
            return registrosEncontrados.length > 0 ? registrosEncontrados : null

        } else {
            return filtro
        }
    }



    const licenciasSertec = async (ORDERCOLUM, ORDERDIR, ID_SOCIO) => {
        setLicencias([]);
        setLicenciasAux([]);

        setEstadoCliente(false);
        setEstadoMostrador(false);
        setFiltroPorDecto(0);
        filtroLocal.PROGRAMAS = []
        filtroLocal.PROGRAMA_SELECCIONADO = 0
        filtroLocal.VERSIONES = []
        filtroLocal.VERSION_SELECCIONADO = 0
        setFiltroLocal({ ...filtroLocal })
        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 })
        let registros = null;


        let licencias = await ObtenerLicenciasInfoEnAPI(0, 1, ORDERCOLUM, ORDERDIR, ID_SOCIO, null, null, false)

        if (licencias !== undefined && licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
            registros = licencias.REGISTROS

            let PROGRMAS = registros.filter((a, i) => registros.findIndex((s) => a.ID_PROGRAMA === s.ID_PROGRAMA) === i)

            let FILTRO_PROGRAMAS = PROGRMAS.map((item) => { return { ID: item.ID_PROGRAMA, DESCRIPCION: item.PROGRAMA } })
            filtroLocal.PROGRAMAS = FILTRO_PROGRAMAS



            setFiltroLocal({ ...filtroLocal })
        }





        setLicencias(registros);
        setLicenciasAux(registros);


        return registros;
    }






    const MailDeRecuperacion = (ID) => {
        EnviarCredencialesInfoEnAPI(ID).then((mail) => {
            if (mail !== undefined) {
                if (mail.OK) {
                    MSGOK(traducirPagina("Mail_enviado"))
                }
            }
        })
    }







    const actualizarCabeceraTabla = (e, valor) => {


        /*
        cabeceraTabla.ID
        cabeceraTabla.Taller
        cabeceraTabla.Sertec
        cabeceraTabla.Id_Usuario_Sertec
        cabeceraTabla.Usuario_Sertec
        cabeceraTabla.Proviene_Red
        cabeceraTabla.Nombre_Red
        cabeceraTabla.Programa
        cabeceraTabla.Version
        cabeceraTabla.Disenyo
        cabeceraTabla.Creación
        cabeceraTabla.Baja
        cabeceraTabla.Activo
*/
        const ID = e === 'ID' ? valor : false;

        const Usuario = e === 'Usuario' ? valor : false;

        const Taller = e === 'Taller' ? valor : false;
        const Sertec = e === 'Sertec' ? valor : false
        const Id_Usuario_Sertec = e === 'Id_Usuario_Sertec' ? valor : false
        const Usuario_Sertec = e === 'Usuario_Sertec' ? valor : false
        const Proviene_Red = e === 'Proviene_Red' ? valor : false
        const Nombre_Red = e === 'Nombre_Red' ? valor : false
        const Programa = e === 'Programa' ? valor : false
        const Version = e === 'Version' ? valor : false
        const Disenyo = e === 'Disenyo' ? valor : false
        const Creación = e === 'Creación' ? valor : false
        const Baja = e === 'Baja' ? valor : false
        const Activo = e === 'Activo' ? valor : false

        setCabeceraTabla(
            {
                ID: ID,
                Usuario: Usuario,
                Taller: Taller,

                Sertec: Sertec,
                Id_Usuario_Sertec: Id_Usuario_Sertec,
                Usuario_Sertec: Usuario_Sertec,
                Proviene_Red: Proviene_Red,
                Nombre_Red: Nombre_Red,
                Programa: Programa,
                Version: Version,
                Disenyo: Disenyo,
                Creación: Creación,
                Baja: Baja,
                Activo: Activo
            }
        )
    }

    const DarDeBajaUsuario = (PAYLOAD) => {
        BajaLicenciaInfoEnAPI(PAYLOAD.ID).then(usuario => {
            if (usuario !== undefined && usuario !== null && usuario.OK) {

                MSGOK(traducirPagina("Usuario_baja"))

                licenciasSertec(1, "A", socioSeleccionado);

                setEstadoCliente(false);
                setEstadoMostrador(false);
                setFiltroPorDecto(0);

            }
        })
    }


    const colorFondoMedia = (media) => {
        if (media < 25) { return "#f9c9c9" }
        if (media >= 25 && media < 50) { return "#f5d698" }
        if (media >= 50 && media < 75) { return "#f5f5b4" }
        if (media >= 75) { return "#e7f9c9" }

    }

    const filtrarDatosLocales = (licencias, esActivo, esMostrador, filtroLocal) => {
        const { PROGRAMA_SELECCIONADO, VERSION_SELECCIONADO } = filtroLocal
        licencias = licencias === null ? [] : licencias
        console.log("licencias ddd", licencias)

        let filtroLicencias = [...licencias];

        if (esActivo > 0) {
            switch (esActivo) {
                case 1:
                    filtroLicencias = licencias.filter((item) => item.BAJA === false)
                    break;
                case 2:
                    filtroLicencias = licencias.filter((item) => item.BAJA === true)
                    break;
            }
        }

        if (PROGRAMA_SELECCIONADO > 0) {
            filtroLicencias = filtroLicencias.filter((item) => item.ID_PROGRAMA === PROGRAMA_SELECCIONADO)
        }


        if (VERSION_SELECCIONADO > 0) {
            filtroLicencias = filtroLicencias.filter((item) => item.ID_VERSION === VERSION_SELECCIONADO)
        }

        if (esMostrador > 0) {
            filtroLicencias = filtroLicencias.filter((item) => (esMostrador === 2) ? item.ES_MOSTRADOR === 0 : item.ES_MOSTRADOR === 1)
        }
        if (textoBuscador !== "") {
            filtroLicencias = filtroLocalDeLaTabla(textoBuscador, filtroLicencias)
        }

        let verificarLicencia = filtroLicencias === undefined || filtroLicencias === null ? null : filtroLicencias.length === 0 ? null : filtroLicencias
        setLicencias(verificarLicencia)
        return verificarLicencia
    }


    const List = React.memo(({ list }) => {
        let datos = [];

        datos = list.map((licencia, i) => (
            (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final ?
                <ListItem key={licencia.ID} licencia={licencia} />
                :
                null
        ))
        return (
            datos
        );
    })

    const ListItem = React.memo(({ licencia }) => {
        return <tr key={licencia.ID} style={{ backgroundColor: '#fff' }}>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.ID}>{licencia.ID}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.USUARIO}>{licencia.USUARIO}</td>

            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_TALLER}>{licencia.NOMBRE_TALLER}</td>



            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.PROVIENE_DE_RED ? <CheckSquareOutlined style={{ fontSize: '18px', color: 'green' }} /> : <CloseSquareOutlined style={{ fontSize: '18px', color: 'red' }} />}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.NOMBRE_RED}>{licencia.NOMBRE_RED}</td>

            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.VERSION}>{licencia.VERSION}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={licencia.DISENYO}>{licencia.DISENYO}</td>



            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.FECHA_ALTA}</td>
            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.FECHA_BAJA}</td>


            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{!licencia.BAJA ? <CheckSquareOutlined style={{ fontSize: '18px', color: 'green' }} /> : <CloseSquareOutlined style={{ fontSize: '18px', color: 'red' }} />}</td>

            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                <div className="flex-container-Grow-Simple">

                    <div style={{ margin: '0px 2px' }} >
                        <button disabled={licencia.BAJA && licencia.CORREO_RECUPERACION_PWD === ""} title={traducirPagina("Enviar_correo_recuperacion")} onClick={() => {
                            if (!licencia.BAJA && licencia.CORREO_RECUPERACION_PWD !== "") {
                                MailDeRecuperacion(licencia.ID);
                            }
                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            <MailOutlined style={{ cursor: 'pointer', fontSize: '20px', color: !licencia.BAJA ? licencia.CORREO_RECUPERACION_PWD === "" ? '#ffb4b4' : '#000' : '#999' }} />
                        </button>
                    </div>


                    <div style={{ margin: '0px 2px' }}>

                        <button disabled={licencia.BAJA} title={traducirPagina("Administrar_licencias")} onClick={() => {
                            setUusuarioSeleccionado(licencia.ID);
                            setAbrirFichaCliente(true)
                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: !licencia.BAJA ? '#000' : '#999' }} />
                        </button>

                    </div>

                    <div style={{ margin: '0px 2px' }} >
                        <button title={traducirPagina("Dar_baja")} onClick={() => {
                            if (!licencia.BAJA) {
                                setRegistroUsuario(licencia)
                                setVisible(true)
                            }
                        }}
                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                            <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: !licencia.BAJA ? '#000' : '#999' }} />

                        </button>
                    </div>
                </div>
            </td>
        </tr>
    });

    const paginarTabla = (page, pageSize) => {
        if (licencias.length > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )
        }
    }

    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: 1,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }



    const modelarDatos = (registros) => {
        const LISTADO_REGISTROS = [...registros];

        let resultado = LISTADO_REGISTROS.map((item) => {
            return {
                ID: item.ID, USUARIO: item.USUARIO, TALLER: item.NOMBRE_TALLER,
                RED: item.PROVIENE_DE_RED ? "SI" : "NO", NOMBRE_RED: item.NOMBRE_RED,
                VERSION: item.VERSION, DISEÑO: item.DISENYO, CREACION: item.FECHA_ALTA, ACTIVO: item.BAJA ? "NO" : "SI"
            }
        })


        return resultado

    }

    const buscarDocumento = () => {


        GetListaHTMLEnAPI(modelarDatos(licencias), "", "LICENCIAS INFOTECHNIC").then((doc) => {
            if (doc !== undefined) {
                if (doc !== null || doc !== "") {
                    setDOC_HTML(doc.HTML)
                } else {
                    setDOC_HTML(null)
                }
            }
        })

    }

    const buscarDocumentoPDF = () => {

        GetListaPDFEnAPI(modelarDatos(licencias), "", "LICENCIAS INFOTECHNIC").then((doc) => {
            if (doc !== undefined) {
                if (doc.PDF !== "" && doc.PDF !== null) {
                    descargarPdfPasandoBase64(doc.PDF)
                }
            }
        })

    }

    const buscarDocumentoCSV = () => {

        GetCSVEnAPI(modelarDatos(licencias), "", "LICENCIAS INFOTECHNIC").then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {

                    descargarDocPasandoBase64Generico(doc.CSV, "csv")

                }
            }
        })
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)

            licenciasSertec(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO);
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO);

        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`NEXT INFOTECHNIC - ${traducirPagina("Licencias").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );



    return (
        <div>


            <div className="menu_mantenimiento" ref={ref}>

                <div className="mantenimiento_item1" style={{ gap: '10px' }}>

                    <div className="grid-container" style={{ backgroundColor: '#eee' }}>
                        <div className="grid-item">
                            <input className="form-control eliminarFoco" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_en_tabla")} style={{ backgroundColor: "transparent", width: '310px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {
                                setLicencias(filtroLocalDeLaTabla(e.target.value, licenciasAux));
                                setTextoBuscador(e.target.value)
                            }} value={textoBuscador} />
                        </div>

                        <div className="grid-item" >
                            <button style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2" onClick={(e) => { setTextoBuscador(""); setLicencias(filtroLocalDeLaTabla("", licenciasAux)); }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>

                        <div className="grid-item barraLateral" ></div>

                        <div className="grid-item">
                            <button onClick={e => { }} style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                        </div>
                    </div>


                    <div>
                        {sociosLocal !== null ?
                            <Select
                                showSearch
                                allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                                defaultValue={obtenerUsuario().SOCIOS[0].ID_SOCIO}
                                size={"large"}
                                placeholder={traducirPagina("Seleccione_socio")}
                                style={{ width: "400px", textAlign: 'left' }}
                                optionFilterProp="children"
                                onChange={(e) => {

                                    if (e === undefined || e === null) {
                                        setLicencias(null)
                                        setFiltroActivo(0)

                                        filtroLocal.PROGRAMA_SELECCIONADO = 0
                                        filtroLocal.VERSION_SELECCIONADO = 0
                                        filtroLocal.PROGRAMAS = []
                                        filtroLocal.VERSIONES = []
                                        setFiltroLocal({ ...filtroLocal })

                                    } else {
                                        setFiltroActivo(0)
                                        setSocioSeleccionado(parseInt(e));
                                        licenciasSertec(1, "A", e);
                                        setTextoBuscador("")
                                        setRegistroTabla([])

                                        setEstadoCliente(false);
                                        setEstadoMostrador(false);
                                        setFiltroPorDecto(0);


                                    }
                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {sociosLocal.length > 0 ?
                                    sociosLocal.map((socio) =>
                                        <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Info_error_socio")}</h4>
                            </div>
                        }
                    </div>

                    <div>
                        <Select
                            showSearch
                            allowClear={true}
                            size={"large"}
                            value={filtroActivo === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Filtrado_activo").toUpperCase()}</span> : filtroActivo === 1 ? traducirPagina("Activo").toUpperCase() : traducirPagina("Desactivo").toUpperCase()}
                            style={{ width: "250px", textAlign: 'left', marginLeft: '10px' }}
                            optionFilterProp="children"
                            onChange={(e) => {
                                const ID_SELECCIONADO = e === undefined || e === null ? 0 : e;

                                setFiltroActivo(ID_SELECCIONADO)
                                filtrarDatosLocales(licenciasAux, ID_SELECCIONADO, filtroPorDecto, filtroLocal)


                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            <Option key={0} value={0}>{traducirPagina("Todos")}</Option>
                            <Option key={1} value={1}>{traducirPagina("Activo").toUpperCase()}</Option>
                            <Option key={2} value={2}>{traducirPagina("Desactivo").toUpperCase()}</Option>
                        </Select>
                    </div>


                    <div >
                        <PrinterOutlined style={{ fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', cursor: 'pointer' }} onClick={(e) => { setABRIR_FICHA_IMPRESION(true); buscarDocumento(); }} />
                    </div>

                    <div>
                        <MDBDropdown>
                            <MDBDropdownToggle nav>
                                <button style={{ height: '40px', width: '50px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', backgroundColor: '#efefef', cursor: 'pointer' }} onClick={() => { setDatosClienteSeleccionado({}); setAbrirFichaSelecionCliente(true); }}><PlusOutlined style={{ fontSize: '20px' }} />  </button>
                            </MDBDropdownToggle>
                        </MDBDropdown>
                    </div>

                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    {licencias !== null ?
                        licencias.length > 0 ?
                            <Pagination
                                showSizeChanger
                                current={datosPaginacion.iniPage}
                                onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                total={licencias.length}
                                showTotal={() => ` ${licencias.length} ${traducirPagina("Licencias")}`}
                                defaultPageSize={40}
                                onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                            > </Pagination>
                            :
                            null
                        : null
                    }

                </div>
            </div>




            <div className="margen_tabla">
                {licencias === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Msg_licencias")}</h4>
                    </div>
                    :
                    licencias.length > 0 ?

                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>

                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("ID", !cabeceraTabla.ID);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.ID ? "ASC" : "DESC", licencias, "ID"))
                                        }}> {traducirPagina("ID")} {cabeceraTabla.ID ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>

                                        <th style={{ width: '220px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Usuario", !cabeceraTabla.Usuario);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Usuario ? "ASC" : "DESC", licencias, "USUARIO"))
                                        }} > {traducirPagina("Usuario")} {cabeceraTabla.Usuario ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Taller", !cabeceraTabla.Taller);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Taller ? "ASC" : "DESC", licencias, "NOMBRE_TALLER"))
                                        }} > {traducirPagina("Taller")} {cabeceraTabla.Taller ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>






                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Proviene_Red", !cabeceraTabla.Proviene_Red);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Proviene_Red ? "ASC" : "DESC", licencias, "PROVIENE_RED"))
                                        }}> {traducirPagina("Red")} {cabeceraTabla.Proviene_Red ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>


                                        <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Nombre_Red", !cabeceraTabla.Nombre_Red);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Nombre_Red ? "ASC" : "DESC", licencias, "NOMBRE_RED"))
                                        }}> {traducirPagina("Nombre_red")} {cabeceraTabla.Nombre_Red ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>





                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Version", !cabeceraTabla.Version);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Version ? "ASC" : "DESC", licencias, "VERSION"))
                                        }}> {traducirPagina("Version")} {cabeceraTabla.Version ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>


                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Disenyo", !cabeceraTabla.Disenyo);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Disenyo ? "ASC" : "DESC", licencias, "DISENYO"))
                                        }}> {traducirPagina("Diseño")} {cabeceraTabla.Disenyo ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />} </th>





                                        <th style={{ width: '140px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Creación", !cabeceraTabla.Creación);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Creación ? "ASC" : "DESC", licencias, "FECHA_ALTA"))
                                        }}> {traducirPagina("Creacion")} {cabeceraTabla.Creación ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>

                                        <th style={{ width: '140px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Baja", !cabeceraTabla.Baja);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Baja ? "ASC" : "DESC", licencias, "FECHA_BAJA"))
                                        }}> {traducirPagina("Baja")} {cabeceraTabla.Baja ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>


                                        <th style={{ width: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => {
                                            actualizarCabeceraTabla("Activo", !cabeceraTabla.Activo);

                                            setLicencias(ordenarTablaLocal(cabeceraTabla.Activo ? "ASC" : "DESC", licencias, "BAJA"))
                                        }}> {traducirPagina("Activo")} {cabeceraTabla.Activo ? <ArrowUpOutlined className="orderTable" /> : <ArrowDownOutlined className="orderTable" />}</th>



                                        <th style={{ width: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <List list={licencias} />
                                </tbody>

                            </table>

                        </div>
                        :

                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>







            {ABRIR_FICHA_IMPRESION ?
                <FichaImpresionGenerico
                    title={traducirPagina("Impresion_doc").toUpperCase()}
                    ABRIR_FICHA={ABRIR_FICHA_IMPRESION}
                    CERRAR_FICHA={setABRIR_FICHA_IMPRESION}
                    DOCUMENTO={DOC_HTML}
                    MODIFICAR_DOCUMENTO={setDOC_HTML}
                    DESCARGAR_DOCUMENTO={buscarDocumentoPDF}
                    DESCARGAR_CSV={buscarDocumentoCSV}
                    VER_CSV={true}
                >
                </FichaImpresionGenerico>
                :
                null
            }

            {abrirFichaSelecionCliente ?
                <ListadoClientes
                    title={traducirPagina("Seleccione_taller").toUpperCase()}
                    ABRIR_FICHA={abrirFichaSelecionCliente}
                    ACTUALIZAR_FICHA={setAbrirFichaSelecionCliente}
                    ID_SOCIO={socioSeleccionado}
                    ABRIR_FICHA_MANTENIMIENTO={setAbrirFichaCliente}
                    DATOS_CLIENTE_SELECCIONADO={setDatosClienteSeleccionado}>

                </ListadoClientes>
                :
                null
            }

            {abrirFichaCliente ?
                <FichaClienteDataInfo
                    title={traducirPagina("Usuario").toUpperCase()}
                    ESTADO_FICHA={abrirFichaCliente}
                    CERRAR_FICHA={setAbrirFichaCliente}
                    DATOS_CLIENTE_SELECCIONADO={setDatosClienteSeleccionado}
                    ID_SOCIO={socioSeleccionado}

                    ID_USUARIO={usuarioSeleccionado}
                    DATOS_CLIENTE={datosClienteSeleccionado}
                    ACTUALIZAR_LICENCIAS={licenciasSertec}
                    TEXTO_BUSCADOR={setTextoBuscador}
                >
                </FichaClienteDataInfo>

                :
                null}



            <Modal
                visible={visible}
                width={600}
                centered
                title={traducirPagina("Dar_baja")}
                afterClose={() => { }}
                onCancel={() => setVisible(false)}
                style={{ zIndex: '99999999' }}
                footer={[
                    <Button key="back" onClick={() => { setVisible(false) }}>
                        {traducirPagina("NO").toUpperCase()}
                    </Button>,
                    <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {
                        DarDeBajaUsuario(registroUsuario)
                        setVisible(false)
                    }}> {traducirPagina("SI").toUpperCase()}</Button>
                ]}
            >
                <Row>
                    <Col md={24} className="mt-2 mb-2">
                        <span className="tituloRecuperarEmail">{`${traducirPagina("Baja_usuario")}: ${registroUsuario.USUARIO}?`} </span>
                    </Col>
                </Row>
            </Modal>
        </div>

    );
}


ContainerLicenciasNextInfo.propTypes = {

};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        configApp: state.configApp,
        usuario: state.usuario,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia,

    };
}

export default connect(mapStateToProps)(ContainerLicenciasNextInfo);


